import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Table from '../../shared/Table/Table';
import { columns, mapData } from './TableMetadata';
import PromissoryFilters from './PromissoryFilters';
import parseQuerystring from '../../../helpers/parseQuerystring';

import combineStyles from '../../../helpers/combineStyles';
import LayoutStyles from '../../../styles/layout';
import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';
import SpacingStyles from '../../../styles/helpers/spacing';
import ListsStyle from '../__styles__/Lists.style';

import { DEFAULT_ROWS_PER_PAGE } from '../../../constants/request_constants';

class PromissoryList extends React.PureComponent {
  state = {
    rowsPerPage: sessionStorage.getItem('BrillaRowsPerPage')
      ? parseInt(sessionStorage.getItem('BrillaRowsPerPage'), 10)
      : DEFAULT_ROWS_PER_PAGE
  };

  componentDidMount() {
    this._fetchItems();
  }

  _fetchItems = params => {
    const query = params || parseQuerystring(this.props) || {};
    this.props.fetchPromissories({
      ...query,
      page: query.page || 1,
      per_page: this.state.rowsPerPage
    });
  };

  _handleChangePage = page => {
    const query = parseQuerystring(this.props) || {};
    this._fetchItems({
      ...query,
      page: page + 1
    });
  };

  _handleRowClick = id => this.props.history.push(`/promissories/${id}`);

  _handleChangeRowsPerPage = rowsPerPage => {
    sessionStorage.setItem('BrillaRowsPerPage', rowsPerPage);
    this.setState({ rowsPerPage: rowsPerPage, page: 1 }, this._fetchItems);
  };

  render() {
    const { promissories, meta = {}, classes, requestSend } = this.props;
    const { page } = parseQuerystring(this.props) || {};
    // console.log('PAGARÉS in View:', promissories, meta)
    return (
      <div>
        <div className={classes.titleRootWrapper}>
          <h1 className={classnames(classes.headline4, classes.title)}>
            {'Pagarés'}
          </h1>
        </div>
        <div>
          <div className={classes.filterOptionsWrapper}>
            <PromissoryFilters onChangeFilter={this._fetchItems} />
          </div>
        </div>
        <div>
          <Table
            name={'Pagaré'}
            columns={columns}
            data={mapData(promissories)}
            onDownloadClick={this._handleDownloadCSV}
            onChangePage={this._handleChangePage}
            onChangePageRowsPerPage={this._handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={this.state.rowsPerPage}
            onClickOnRow={props => this._handleRowClick(props.id)}
            totalCount={promissories.length}
            loading={requestSend}
            withNoCountPagination={true}
            nextPage={meta.nextPage}
          />
        </div>
      </div>
    );
  }
}

const styles = (/* theme */) => ({});

PromissoryList.propTypes = {
  classes: PropTypes.object.isRequired,
  promissories: PropTypes.array.isRequired,
  fetchPromissories: PropTypes.func.isRequired,
  meta: PropTypes.object,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default withStyles(
  combineStyles(
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles,
    ListsStyle,
    styles
  )
)(PromissoryList);
